import React from "react";
import Svg, { Path, Defs, LinearGradient as LG, Stop } from "react-native-svg";

const GradientBackground = ({
  width,
  height,
  color,
  children,
}: {
  width: number;
  height: number;
  color: string;
  children: React.JSX.Element;
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 300 300" fill="none">
      <Path fill="url(#paint0_linear_13141_22395)" d="M0 0H150V150H0z" />
      <Path fill="url(#paint1_linear_13141_22395)" d="M0 150H150V300H0z" />
      <Path fill="url(#paint2_linear_13141_22395)" d="M150 150H300V300H150z" />
      <Path fill="url(#paint3_linear_13141_22395)" d="M150 0H300V150H150z" />
      <Defs>
        <LG
          id="paint0_linear_13141_22395"
          x1={150}
          y1={75}
          x2={75}
          y2={150}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor={color} />
          <Stop offset={1} stopColor={color} stopOpacity={0.75} />
        </LG>
        <LG
          id="paint1_linear_13141_22395"
          x1={75}
          y1={150}
          x2={150}
          y2={225}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0} stopColor={color} stopOpacity={0.75} />
          <Stop offset={1} stopColor={color} stopOpacity={0.5} />
        </LG>
        <LG
          id="paint2_linear_13141_22395"
          x1={225}
          y1={150}
          x2={150}
          y2={225}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor={color} stopOpacity={0.25} />
          <Stop offset={1} stopColor={color} stopOpacity={0.5} />
        </LG>
        <LG
          id="paint3_linear_13141_22395"
          x1={150}
          y1={75}
          x2={225}
          y2={150}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor={color} stopOpacity={0} />
          <Stop offset={1} stopColor={color} stopOpacity={0.25} />
        </LG>
      </Defs>
      {children}
    </Svg>
  );
};

export default GradientBackground;
